import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTornaIndietro } from '../common/navigazione';
import { getCorriere } from '../services/api';
import { Container, Card, Button, Row, Col, Spinner, Alert } from 'react-bootstrap';

function CorrieriDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const tornaIndietro = useTornaIndietro('/corrieri');
  const [corriere, setCorriere] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCorriere = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await getCorriere(id);
        setCorriere(response.data);
      } catch (err) {
        setError('Errore nel caricamento del corriere.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchCorriere();
  }, [id]);

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" />
        <p>Caricamento corriere...</p>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">{error}</Alert>
        <Button variant="primary" onClick={tornaIndietro}>Torna alla lista corrieri</Button>
      </Container>
    );
  }

  if (!corriere) {
    return (
      <Container className="mt-5">
        <Alert variant="warning">Corriere non trovato.</Alert>
        <Button variant="primary" onClick={tornaIndietro}>Torna alla lista corrieri</Button>
      </Container>
    );
  }

  return (
    <Container className="mt-4">
      <Row className="mb-3 align-items-center">
        <Col>
          <h2 className="mb-0">Dettaglio Corriere: {corriere.denominazione}</h2>
        </Col>
        <Col xs="auto" className="ms-auto">
          <Button variant="secondary" onClick={tornaIndietro} className="me-2">
            Torna alla Lista
          </Button>
          <Button variant="warning" onClick={() => navigate(`/corrieri/edit/${id}`)} className="me-2">
            Modifica
          </Button>
          <Button variant="info" onClick={() => window.print()} disabled={loading}>
            Stampa
          </Button>
        </Col>
      </Row>

      <Card className="mb-4">
        <Card.Header as="h5">Dati Corriere</Card.Header>
        <Card.Body>
          <Row>
            <Col md={6}>
              <Row className="mb-2">
                <Col xs={4}><strong>ID:</strong></Col>
                <Col xs={8}>{corriere.id}</Col>
              </Row>
              <Row className="mb-2">
                <Col xs={4}><strong>Denominazione:</strong></Col>
                <Col xs={8}>{corriere.denominazione}</Col>
              </Row>
              <Row className="mb-2">
                <Col xs={4}><strong>Referente:</strong></Col>
                <Col xs={8}>{corriere.referente || 'N/A'}</Col>
              </Row>
            </Col>
            <Col md={6}>
              <Row className="mb-2">
                <Col xs={4}><strong>Telefono:</strong></Col>
                <Col xs={8}>{corriere.telefono || 'N/A'}</Col>
              </Row>
              <Row className="mb-2">
                <Col xs={4}><strong>Cellulare:</strong></Col>
                <Col xs={8}>{corriere.cellulare || 'N/A'}</Col>
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Header as="h5">Dati Spedizione</Card.Header>
        <Card.Body>
          <Row>
            <Col md={6}>
              <Row className="mb-2">
                <Col xs={4}><strong>Tipo Spedizione:</strong></Col>
                <Col xs={8}>{corriere.tipo_spedizione || 'N/A'}</Col>
              </Row>
            </Col>
            <Col md={6}>
              <Row className="mb-2">
                <Col xs={4}><strong>Costo reale spedizione:</strong></Col>
                <Col xs={8}>
                  {corriere.costo_ivato ? `€ ${corriere.costo_ivato.toFixed(2)} ivati` : (corriere.costo ? `€ ${corriere.costo.toFixed(2)}` : 'N/A')}
                  {corriere.costo_ivato ? ` · sconto ricariche ${corriere.sconto_ricarica_pct || 0}% · netto € ${Number(corriere.costo_netto_effettivo || 0).toFixed(2)}${corriere.iva_detraibile === false ? '' : ' (IVA detraibile)'}` : ''}
                </Col>
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default CorrieriDetail;